// apps/web/src/lib/kanban/deep-link.ts — Fase 12, Plano 21 (PV-05).
// Deep-link do detalhe do PV para o Kanban: `/planejamento/kanban?op={numero}`.
// Só números inteiros positivos passam: o valor da URL nunca é usado sem validação.
import type { KanbanCartao, KanbanQuadro } from '@pieltec/contracts';

/** Número da OP da query string (`?op=123`); vazio, ausente ou não numérico vira null. */
export function lerOpDoDeepLink(search: string): string | null {
  const valor = new URLSearchParams(search).get('op')?.trim() ?? '';
  return /^\d+$/.test(valor) ? valor : null;
}

/**
 * Cartão do quadro que representa a OP. Uma OP pode ter cartões em mais de uma raia
 * (etapas): prefere o que ainda está em andamento; sem ele, o primeiro encontrado.
 */
export function localizarCartaoDaOp(quadro: KanbanQuadro, opNumero: string): KanbanCartao | null {
  let primeiro: KanbanCartao | null = null;
  for (const coluna of quadro.colunas) {
    for (const raia of coluna.raias) {
      for (const cartao of raia.cartoes) {
        if (cartao.opNumero !== opNumero) continue;
        if (cartao.estado !== 'CONCLUIDO') return cartao;
        primeiro ??= cartao;
      }
    }
  }
  return primeiro;
}
